export const workTypeOptions = [
  { value: 'ONSITE', label: '대면' },
  { value: 'REMOTE', label: '원격' },
  { value: 'HYBRID', label: '혼합' },
] as const

export const projectDomainOptions = [
  { value: 'DESIGN', label: '디자인' },
  { value: 'DEVELOPMENT', label: '개발' },
  { value: 'BRANDING', label: '브랜딩' },
  { value: 'MARKETING', label: '마케팅' },
  { value: 'CONTENT', label: '콘텐츠' },
  { value: 'RESEARCH', label: '리서치' },
  { value: 'PM_OPS', label: 'PM/운영' },
  { value: 'OTHER', label: '기타' },
] as const

export const resultPresetOptions = [
  {
    id: 'SHORTS_REELS',
    title: '🎥 쇼츠/콘텐츠 제작',
    domains: ['CONTENT'],
    roles: ['CONTENT_DESIGNER', 'UX_UI_DESIGNER', 'PM'],
    titleTemplate: '쇼츠 30개 제작 + 썸네일 패키지',
    summaryTemplate: '콘텐츠 제작을 팀(매니저+메이커)으로 운영해 채널 성과를 만들고 싶어요.',
    descriptionTemplate: `채널: (유튜브/인스타/틱톡)
목표: (팔로워/리드/매출)
주당 업로드 수:
레퍼런스 링크(3개):
톤앤매너(키워드 3개):
제공 자료(원본/스크립트/브랜드 가이드):
납기/검수 방식:`,
    defaultMode: 'TEAM',
  },
  {
    id: 'LANDING_PAYMENT',
    title: '🧲 랜딩/세일즈 인프라 구축',
    domains: ['DEVELOPMENT', 'DESIGN'],
    roles: ['FRONTEND', 'UX_UI_DESIGNER', 'PM'],
    titleTemplate: '코칭/강의 랜딩 + 결제/자동메일 세팅',
    summaryTemplate: '랜딩 제작부터 결제까지 팀으로 빠르게 런칭하고 싶어요.',
    descriptionTemplate: `판매 오퍼(상품명/가격/구성):
결제 방식(토스/스트라이프/네이버페이 등):
필수 섹션(후기/FAQ/환불정책 등):
레퍼런스 링크:
추적(픽셀/GA) 필요 여부:
도메인/호스팅 보유 여부:`,
    defaultMode: 'TEAM',
  },
  {
    id: 'EBOOK_COURSE_LAUNCH',
    title: '🚀 MVP/PoC 제작',
    domains: ['CONTENT', 'MARKETING'],
    roles: ['CONTENT_DESIGNER', 'MARKETER', 'PM'],
    titleTemplate: '전자책/강의 런칭: 기획+세일즈페이지+소재',
    summaryTemplate: '콘텐츠/코칭 상품 런칭을 매니저+메이커 팀으로 진행하고 싶어요.',
    descriptionTemplate: `런칭 일정(오픈일):
타겟(누구의 어떤 문제):
제공물(전자책/강의/코칭):
기존 채널(팔로워/메일리스트):
필요한 결과물(세일즈페이지/광고소재/메일):
레퍼런스/톤:`,
    defaultMode: 'TEAM',
  },
  {
    id: 'NEWSLETTER_BLOG',
    title: '🧩 제품/서비스 리뉴얼',
    domains: ['CONTENT'],
    roles: ['CONTENT_DESIGNER', 'RESEARCHER', 'PM'],
    titleTemplate: '뉴스레터 주 1회 운영(리서치+편집+발행)',
    summaryTemplate: '정기 콘텐츠 운영을 팀으로 안정적으로 만들고 싶어요.',
    descriptionTemplate: `주제/카테고리:
발행 주기:
타겟 독자:
참고 채널(3개):
원고 제공 여부:
발행 툴(스티비/메일침프 등):`,
    defaultMode: 'TEAM',
  },
  {
    id: 'AD_PERFORMANCE',
    title: '📈 광고/마케팅 실행',
    domains: ['MARKETING'],
    roles: ['MARKETER', 'UX_UI_DESIGNER', 'PM'],
    titleTemplate: '메타/구글 광고 세팅 + 소재 10종',
    summaryTemplate: '광고 세팅과 소재 제작을 팀으로 묶어 성과를 만들고 싶어요.',
    descriptionTemplate: `월 예산:
목표(CPA/ROAS):
랜딩 보유 여부:
계정 권한(광고계정/픽셀):
소재 방향(후킹 문구/비주얼):
레퍼런스:`,
    defaultMode: 'TEAM',
  },
  {
    id: 'TEAM_MATCHING_ONLY',
    title: '🤝 팀 매칭만 먼저(역할만 정하고 상담)',
    domains: ['PM_OPS'],
    roles: ['PM'],
    titleTemplate: '콘텐츠/런칭 팀 구성 상담',
    summaryTemplate: '지금 필요한 역할부터 정하고 팀 매칭 상담을 먼저 받고 싶어요.',
    descriptionTemplate: `지금 막힌 부분(1줄):
원하는 역할(2개):
예산 범위:
일정:`,
    defaultMode: 'TEAM',
  },
] as const

export const neededRoleOptions = [
  { value: 'UX_UI_DESIGNER', label: 'UX/UI 디자이너' },
  { value: 'BX_DESIGNER', label: 'BX 디자이너' },
  { value: 'RESEARCHER', label: '리서처' },
  { value: 'CONTENT_DESIGNER', label: '콘텐츠 디자이너' },
  { value: 'FRONTEND', label: '프론트엔드' },
  { value: 'BACKEND', label: '백엔드' },
  { value: 'PM', label: 'PM' },
  { value: 'MARKETER', label: '마케터' },
  { value: 'ILLUSTRATOR', label: '일러스트레이터' },
] as const

export const periodOptions = [
  '1개월 이하',
  '1~3개월',
  '3~6개월',
  '6개월~1년',
] as const

export const costOptions = [
  '500만원 이하',
  '500~1000만원',
  '1000~5000만원',
  '5000~1억원',
  '1억원 이상',
] as const

export const designLevelOptions = [
  { value: 'ENTRY', label: '주니어도 가능' },
  { value: 'INTERMEDIATE', label: '중급 이상' },
  { value: 'EXPERT', label: '전문가 필요' },
] as const

export const engagementTypeOptions = [
  { value: 'ONE_OFF', label: '단발(한 번에 끝나는 작업)' },
  { value: 'ONGOING', label: '지속(운영/반복 작업)' },
  { value: 'ONE_OFF_EXTENDABLE', label: '단발 + 연장 가능' },
] as const

export const weeklyHoursOptions = [
  { value: 'LT_5', label: '주 5시간 미만' },
  { value: 'H_5_10', label: '주 5~10시간' },
  { value: 'H_10_20', label: '주 10~20시간' },
  { value: 'H_20_30', label: '주 20~30시간' },
  { value: 'GT_30', label: '주 30시간 이상' },
] as const

export const materialsOptions = [
  { value: 'DESIGN_SYSTEM_EXISTS', label: '디자인 시스템/컴포넌트가 있어요' },
  { value: 'BRAND_GUIDE_EXISTS', label: '브랜드 가이드가 있어요' },
  { value: 'ANALYTICS_AVAILABLE', label: '분석 데이터/픽셀 접근이 가능해요' },
  { value: 'USER_RESEARCH_AVAILABLE', label: '리서치 자료가 있어요' },
] as const

export const onboardingSteps = [
  { label: '기업 프로필 완성', path: '/onboarding/enterprise/company' },
  { label: '기업 견적서 작성', path: '/client/projects/new' },
] as const
